// Menu Item 1047 / NavBar 1047 — BDU main nav (bduedu.in `organisms/Header`).
// White bar: logo left, nav links right with dropdowns, gradient "Apply" CTA.
//
// Unlike the other navbar variants this menu is THREE levels deep — a top-level
// item (Programmes) holds programmes, and a programme holds its specialisations,
// which expand inline inside the dropdown. `menu_item.parent_id` is
// self-referential, so the extra level needs no schema change: add the
// specialisation with its programme selected as Parent Menu.
//
// Reuses the shared nav_bar / menu_item columns. Two columns are added for this
// variant (migration 20260817120000) because BDU paints two of its accents as
// gradients where every other navbar is flat: `active_menu_color_2` (active nav
// link) and `cta3_bg_color_2` (Apply CTA). Leave either empty for a solid fill.

export const NAVBAR_1047_CONSTANTS = {
  DEFAULT_ROW: {
    id: "",
    logo_icon: "",
    logo_icon_alt: "",
    mobile_logo_icon: "",
    mobile_logo_icon_alt: "",
    // Bar
    background_color: "#FFFFFF",
    nav_text_color: "#1B1B1B",
    active_menu_color: "#FF0013",
    active_menu_color_2: "#990013",
    // v1's Tailwind default border colour — it overrides gray.200 to #7C8493, and
    // `borderColor.DEFAULT` resolves to gray.200. A 10% black line reads far
    // fainter than the dropdown card / specialisation dividers on bduedu.in.
    border_color: "#7C8493",
    mobile_menu_text_color: "#1B1B1B",
    // Dropdown
    dropdown_bg_color: "#FFFFFF",
    dropdown_text_color: "#1B1B1B",
    show_dropdown_icons: false,
    // CTA (Apply)
    cta3_enabled: true,
    cta3_label: "Apply",
    cta3_href: "",
    cta3_bg_color: "#FF0013",
    cta3_bg_color_2: "#990013",
    cta3_text_color: "#FFFFFF",
    // Mobile chrome
    hamburger_icon: "",
    hamburger_icon_alt: "",
    mobile_cancel_icon: "",
    mobile_cancel_icon_alt: "",
    sticky_to_top: true,
    status: true,
  },

  NAVBAR_FIELDS_CONFIG: [
    // --- Logo ---
    { fieldName: "logo_icon", label: "Logo", value: "", valueType: "string", filedType: "FILE", placeholder: "Upload logo (180x42)", required: true, defaultValue: "" },
    { fieldName: "logo_icon_alt", label: "Logo Alt Text", value: "", valueType: "string", filedType: "INPUT", placeholder: "Enter logo alt text", required: false, defaultValue: "" },
    { fieldName: "mobile_logo_icon", label: "Mobile Logo (optional)", value: "", valueType: "string", filedType: "FILE", placeholder: "Falls back to the logo above", required: false, defaultValue: "" },
    { fieldName: "mobile_logo_icon_alt", label: "Mobile Logo Alt Text", value: "", valueType: "string", filedType: "INPUT", placeholder: "Enter mobile logo alt text", required: false, defaultValue: "" },

    // --- Bar colours ---
    { fieldName: "background_color", label: "Bar Background Color", value: "#FFFFFF", valueType: "string", filedType: "COLOR", placeholder: "#FFFFFF", required: false, defaultValue: "#FFFFFF" },
    { fieldName: "nav_text_color", label: "Menu Text Color", value: "#1B1B1B", valueType: "string", filedType: "COLOR", placeholder: "#1B1B1B", required: false, defaultValue: "#1B1B1B" },
    { fieldName: "active_menu_color", label: "Active Link Color (gradient start)", value: "#FF0013", valueType: "string", filedType: "COLOR", placeholder: "#FF0013", required: false, defaultValue: "#FF0013" },
    { fieldName: "active_menu_color_2", label: "Active Link Color (gradient end — empty for solid)", value: "#990013", valueType: "string", filedType: "COLOR", placeholder: "#990013", required: false, defaultValue: "#990013" },
    { fieldName: "border_color", label: "Border / Divider Color", value: "#7C8493", valueType: "string", filedType: "COLOR", placeholder: "#7C8493", required: false, defaultValue: "#7C8493" },
    { fieldName: "mobile_menu_text_color", label: "Menu Text Color (Mobile drawer)", value: "#1B1B1B", valueType: "string", filedType: "COLOR", placeholder: "#1B1B1B", required: false, defaultValue: "#1B1B1B" },

    // --- Dropdown (nested menu items) ---
    { fieldName: "dropdown_bg_color", label: "Dropdown BG Color", value: "#FFFFFF", valueType: "string", filedType: "COLOR", placeholder: "#FFFFFF", required: false, defaultValue: "#FFFFFF" },
    { fieldName: "dropdown_text_color", label: "Dropdown Text Color", value: "#1B1B1B", valueType: "string", filedType: "COLOR", placeholder: "#1B1B1B", required: false, defaultValue: "#1B1B1B" },
    { fieldName: "show_dropdown_icons", label: "Show Dropdown Icons", value: false, valueType: "boolean", filedType: "TOGGLE", placeholder: "Show icons on dropdown items", defaultValue: false },

    // --- CTA (Apply) ---
    { fieldName: "cta3_enabled", label: "Show Apply Button", value: true, valueType: "boolean", filedType: "TOGGLE", placeholder: "Enable the Apply button", defaultValue: true },
    { fieldName: "cta3_label", label: "Apply Button Label", value: "Apply", valueType: "string", filedType: "INPUT", placeholder: "Apply", required: false, defaultValue: "Apply" },
    { fieldName: "cta3_href", label: "Apply Button Link", value: "", valueType: "string", filedType: "INPUT", placeholder: "Leave empty to open the lead form popup", required: false, defaultValue: "" },
    { fieldName: "cta3_bg_color", label: "Apply BG (gradient start)", value: "#FF0013", valueType: "string", filedType: "COLOR", placeholder: "#FF0013", required: false, defaultValue: "#FF0013" },
    { fieldName: "cta3_bg_color_2", label: "Apply BG (gradient end — empty for solid)", value: "#990013", valueType: "string", filedType: "COLOR", placeholder: "#990013", required: false, defaultValue: "#990013" },
    { fieldName: "cta3_text_color", label: "Apply Text Color", value: "#FFFFFF", valueType: "string", filedType: "COLOR", placeholder: "#FFFFFF", required: false, defaultValue: "#FFFFFF" },

    // --- Mobile chrome ---
    { fieldName: "show_hamburger", label: "Show Hamburger Menu on Mobile", value: true, valueType: "boolean", filedType: "TOGGLE", placeholder: "Show the hamburger icon on the mobile bar (hides the drawer when off)", defaultValue: true },
    { fieldName: "hamburger_icon", label: "Hamburger Icon", value: "", valueType: "string", filedType: "FILE", placeholder: "Upload hamburger icon (optional)", required: false, defaultValue: "" },
    { fieldName: "hamburger_icon_alt", label: "Hamburger Icon Alt", value: "", valueType: "string", filedType: "INPUT", placeholder: "Menu", required: false, defaultValue: "" },
    { fieldName: "mobile_cancel_icon", label: "Mobile Close Icon", value: "", valueType: "string", filedType: "FILE", placeholder: "Upload close icon (optional)", required: false, defaultValue: "" },
    { fieldName: "mobile_cancel_icon_alt", label: "Mobile Close Icon Alt", value: "", valueType: "string", filedType: "INPUT", placeholder: "Close", required: false, defaultValue: "" },

    { fieldName: "sticky_to_top", label: "Stick to top on scroll", value: true, valueType: "boolean", filedType: "TOGGLE", placeholder: "Pin the nav while scrolling", defaultValue: true },
    { fieldName: "status", label: "Status", value: true, valueType: "boolean", filedType: "TOGGLE", placeholder: "Enable/Disable widget", defaultValue: true },
  ],
};

export const MENU_ITEM_1047_CONSTANTS = {
  DEFAULT_ROW: {
    id: "",
    parent_id: null,
    title: "",
    slug: "",
    url: "",
    status: true,
    priority: 1,
    text_color: "",
    icon: "",
    icon_alt: "",
  },

  MENU_FIELDS_CONFIG: [
    { fieldName: "title", label: "Title", value: "", valueType: "string", filedType: "INPUT", placeholder: "Enter menu title (e.g., Programmes)", required: true, defaultValue: "" },
    { fieldName: "parent_id", label: "Parent Menu", value: null, valueType: "string", filedType: "SELECT", placeholder: "Select parent menu (pick a programme for a specialisation)", required: false, defaultValue: null, options: [] },
    { fieldName: "slug", label: "Slug", value: "", valueType: "string", filedType: "INPUT", placeholder: "Auto-generated from title", defaultValue: "" },
    { fieldName: "url", label: "URL", value: "", valueType: "string", filedType: "INPUT", placeholder: "/online-mba or https://… (optional)", required: false, defaultValue: "" },
    { fieldName: "priority", label: "Priority", value: 1, valueType: "number", filedType: "INPUT", placeholder: "Enter display priority", required: true, defaultValue: 1 },
    { fieldName: "status", label: "Status", value: true, valueType: "boolean", filedType: "TOGGLE", placeholder: "Enable/Disable menu item", defaultValue: true },
    { fieldName: "text_color", label: "Text Color", value: "", valueType: "string", filedType: "COLOR", placeholder: "Leave empty to inherit the navbar colors", required: false, defaultValue: "" },
    { fieldName: "icon", label: "Dropdown Item Icon", value: "", valueType: "string", filedType: "FILE", placeholder: "Upload item icon (optional)", required: false, defaultValue: "" },
    { fieldName: "icon_alt", label: "Dropdown Item Icon Alt", value: "", valueType: "string", filedType: "INPUT", placeholder: "Enter icon alt text", required: false, defaultValue: "" },
  ],

  TREE_CONFIG: {
    treeTitle: "Menu Structure",
    treeIcon: "🌳",
    emptyMessage: "No menu items yet. Add your first one below.",

    itemDisplayFields: {
      primary: "title",
      secondary: "slug",
      statusField: "status",
      statusInactiveLabel: "Inactive",
      childrenField: "children",
    },

    fieldMappings: {
      id: "id",
      parentId: "parent_id",
      orderIndex: "priority",
      title: "title",
      slug: "slug",
      url: "url",
      isActive: "status",
    },

    parentFieldName: "parent_id",
    parentTopLevelValue: "null",
    parentTopLevelLabel: "-- Top Level --",

    formLabels: {
      addNew: "➕ Add New Menu Item",
      edit: "✏️ Edit Menu Item",
      saveButton: "Add Menu Item",
      updateButton: "Update Menu Item",
      newButton: "New",
      cancelButton: "Cancel",
    },

    deleteConfirmation: (item: any) =>
      `Delete "${item.title}"? This will also delete all child items.`,

    requiresParentComponent: true,
    parentComponentName: "Navbar",
    parentIdFieldName: "navbar_id",
    childItemsFieldName: "menuItems",
    parentComponentTitle: "Navbar Settings",
    parentComponentSaveButtonText: "Save Navbar Settings",
    parentComponentCreateSuccessMessage: "Navbar created successfully",
    parentComponentUpdateSuccessMessage: "Navbar settings saved successfully",
    requireParentMessage:
      "Please save the Navbar Settings first before creating menu items. The navbar must be created before you can add menu items.",
    parentComponentMessage: {
      title: "Navbar Not Created Yet",
      description:
        "Please save the Navbar Settings above before adding menu items.",
    },
    // BDU's bar carries seven top-level links; leave headroom without letting
    // the row wrap.
    itemLimits: { max: 10 },
  },
};
